/// Só o que o texto do template precisa: o corpo e as variáveis na ordem.
interface TemplateText {
    body: string;
    variables: string[];
}

/// Variáveis que ficam com quem envia; mesma ordem e regra do servidor, que casa por posição.
export const freeVariables = (template: TemplateText, known: Record<string, string>) =>
    template.variables.filter((name) => !(name in known));

/// O texto fixo é aprovado pela Meta; só as variáveis mudam por envio.
export function fillTemplate(
    template: TemplateText,
    known: Record<string, string>,
    values: string[]
): string {
    let next = 0;

    const valueOf = template.variables.map((name) => {
        if (name in known) return known[name];
        return values[next++] || `{{${name}}}`;
    });

    return template.variables.reduce(
        (text, name, index) => text.split(`{{${name}}}`).join(valueOf[index]),
        template.body);
}
